import MfaChallenge from "./MfaChallenge.container";

export default MfaChallenge;